import { render } from "./cockroach.vue?vue&type=template&id=bfd57894&scoped=true&ts=true"
import script from "./cockroach.vue?vue&type=script&lang=ts"
export * from "./cockroach.vue?vue&type=script&lang=ts"

import "./cockroach.vue?vue&type=style&index=0&id=bfd57894&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd57894"]])

export default __exports__